// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2fEgu","selected":"Chip_selected__2UpiW"};